import clsx from 'clsx';

import { InspectorHeader } from '../InspectorHeader/InspectorHeader';
import IconPageSettings from '@/assets/icons/icon-page-settings.svg?react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { ContentAreaFull } from '@/components/inspector-fields/ContentAreaFull/ContentAreaFull';
import { ContentWidthFull } from '@/components/inspector-fields/ContentWidthFull/ContentWidthFull';
import NodeColorField from '@/components/inspector-fields/ColorField/NodeColorField';

import { NodeGapSettingsV2 } from '@/components/inspector-fields/PaddingMarginFields/NodeGapSettingsV2';
import NodeBackgroundSettings from '@/components/inspector-fields/BackgroundImage/NodeBackgroundSettings';

interface InspectorPageSettingsProps {
  className: string;
  text: string;
}

export const InspectorPageSettings: React.FC<InspectorPageSettingsProps> = ({
  className,
  text = 'Page Settings',
}) => {
  return (
    <div
      className={clsx(
        'inspector bg-neutral-0 relative z-10 inline-flex h-[calc(100vh-52px)] max-w-[240px] flex-col border-l border-neutral-100',
        className,
      )}
    >
      <InspectorHeader
        className="max-w-[240px] text-neutral-900"
        icon={IconPageSettings}
        text={text}
      />
      <ScrollArea className="h-[calc(100vh-104px)] overflow-hidden">
        <div className="flex flex-col gap-3 p-3">
          <ContentAreaFull
            className=""
            onClick={() => {}}
            text="Publish"
            data-qa-selector="inspector-page-settings-content-area"
          />

          <ContentWidthFull
            className=""
            onClick={() => {}}
            text="Publish"
            data-qa-selector="inspector-page-settings-content-width"
          />

          <NodeGapSettingsV2 data-qa-selector="inspector-page-settings-gap" />

          <div className="my-1 h-0 self-stretch border-t border-neutral-100" />

          <p className="pb-1 text-xs font-semibold text-neutral-900">Appearance</p>

          <NodeColorField
            propertyName="backgroundColor"
            solidPropertyName="bgSolid"
            gradientPropertyName="bgGradient"
            gradientEnabled
            label="Page Color"
            data-qa-selector="inspector-page-settings-page-color"
          />

          <div className="my-1 h-0 self-stretch border-t border-neutral-100" />

          <NodeBackgroundSettings data-qa-selector="inspector-page-settings-background" />
        </div>
      </ScrollArea>
    </div>
  );
};
